/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Judge_Call_AlertInputs */



/**
* | output |
* | --- |
* | "Judge Call!" |
*
* @param {Judge_Call_AlertInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const judge_call_alert = /** @type {((inputs?: Judge_Call_AlertInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Judge_Call_AlertInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appel arbitre !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Llamada al juez!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Chamada de juiz!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiamata giudice!")
	return /** @type {LocalizedString} */ ("Judge Call!")
});